import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import WorkWithUs from "../components/sections/WorkWithUs";
import BookRideSection from "../components/sections/BookRideSection";
import BlogDetailsSkeleton from "../components/skeletons/BlogDetailsSkeleton";
import StickyBookCab from "../components/StickyBookCab";
import BookingInquiryModal from "../components/common/modals/BookingInquiryModal";


const BlogDetails = () => {
  // const location = useLocation();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Get slug from URL
  const { slug } = useParams(); // <-- get slug from URL
  // console.log('slug', slug);
  useEffect(() => {
    if (!slug) {
      setError("Invalid blog URL");
      setLoading(false);
      return;
    }

    const fetchBlog = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_APP_DOMAIN}/api/customer/website_blog/${slug}`
        );
        setBlog(res.data.blog);
        setLoading(false);

        // Update head dynamically
        const b = res.data.blog;
        document.title = b.meta_title ?? b.title;

        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
          metaDescription = document.createElement("meta");
          metaDescription.name = "description";
          document.head.appendChild(metaDescription);
        }
        metaDescription.content = b.meta_description ?? "";

        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
          metaKeywords = document.createElement("meta");
          metaKeywords.name = "keywords";
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = b.meta_keywords ?? "";
      } catch (err) {
        console.error(err);
        setError("Blog not found");
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  // if (loading) return <div className="text-center py-5">Loading...</div>;
  if (loading) return <BlogDetailsSkeleton />;
  if (error) return <div className="text-center py-5">{error}</div>;

  return (
    <>
      <section className="blog_wrap section_pb section_pt">
        <div className="container">
          <div className="row justify-content-center g-4">
            <div className="col-md-9 col-sm-12 col-12">
              <div className="blogDetail_col">
                <div className="blogDetail_text">
                  <h1>{blog.title}</h1>
                  {/* <span>{blog.formatted_date}</span> */}
                </div>
                <div className="blogFetail_image">
                  <img
                    src={blog.image_url ?? "/assets/img/all-images/default_blog.png"}
                    alt={blog.title}
                  />
                </div>
              </div>
              <div
                className="blogDetail_description"
                dangerouslySetInnerHTML={{ __html: blog.description ?? "" }}
              ></div>
              <div className="blog_tags">
                <hr />
                {blog.meta_keywords &&
                  blog.meta_keywords.split(",").map((tag, index) => (
                    <span key={index}>{tag.trim()}</span>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Work with us section */}
      <WorkWithUs />

      {/* Book ride section */}
      <BookRideSection />
      {/* Sticky CTA */}
      {/* <StickyBookCab /> */}
        {/* Modal */}
      <BookingInquiryModal bookingType="blog" />
    </>
  );
};

export default BlogDetails;
